<template>
  <div class="container">
    <template v-if="item">
      <div class="hash_tag_list">
        <div v-if="tag.active" class="hash_tag_list_item" v-for="tag in item.tags">
          <span>#{{ tag.title }}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: "HashTagsBlock",
  components: {},
  props: {
    /**props**/
    /**props**/
  },
  computed: {
    item() {
      return this.$context?.item || {}
    }
  }
}
</script>
